import { Enum } from "./Enum";

export const E_ENQUIRY_REPORT = Object.freeze({
  MAIN: "/contact-sale-submission-report",
  DELETE: (id: string) => `/contact-sale-submission-report/${id}`,
  UPDATE: (id: string) => `/contact-sale-submission-report/${id}`,
});

export type E_ENQUIRY = Enum<typeof E_ENQUIRY_REPORT>;
